<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div
              class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3 d-flex justify-content-between align-items-center"
            >
              <h6 class="text-white text-capitalize ps-3">全站折扣活動管理</h6>
              <div class="pe-3">
                <router-link
                  to="/marketing/promotions/new"
                  class="btn btn-sm bg-gradient-light mb-0"
                >
                  <i class="material-icons text-sm">add</i> 新增活動
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      活動名稱
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      類型
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      優先級
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      狀態
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      有效期
                    </th>
                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="promotion in promotions" :key="promotion.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ promotion.title }}</h6>
                          <p
                            class="text-xs text-secondary mb-0"
                            v-if="promotion.code"
                          >
                            代碼: {{ promotion.code }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        {{ getTypeName(promotion.type) }}
                      </p>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ promotion.priority }}
                      </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        class="badge badge-sm"
                        :class="
                          promotion.is_active
                            ? 'bg-gradient-success'
                            : 'bg-gradient-secondary'
                        "
                      >
                        {{ promotion.is_active ? "啟用" : "停用" }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatDate(promotion.starts_at) }} ~
                        {{ formatDate(promotion.ends_at) }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <router-link
                        :to="'/marketing/promotions/' + promotion.id + '/edit'"
                        class="text-secondary font-weight-bold text-xs me-3"
                        data-toggle="tooltip"
                        data-original-title="Edit"
                      >
                        編輯
                      </router-link>
                      <a
                        href="javascript:;"
                        class="text-danger font-weight-bold text-xs"
                        @click="deletePromotion(promotion.id)"
                      >
                        刪除
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="p-3 text-center" v-if="promotions.length === 0">
              無資料
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request";
import Swal from "sweetalert2";

export default {
  name: "Promotions",
  data() {
    return {
      promotions: [],
    };
  },
  mounted() {
    this.fetchPromotions();
  },
  methods: {
    async fetchPromotions() {
      try {
        const response = await axios.get("/api/admin/promotions");
        // If paginated
        this.promotions = response.data.data
          ? response.data.data
          : response.data;
      } catch (error) {
        console.error("Error fetching promotions:", error);
      }
    },
    getTypeName(type) {
      const map = {
        buy_x_get_y: "買 X 送 Y",
        spend_x_get_y: "滿額贈禮",
        spend_x_off: "滿額折扣",
        buy_n_off: "任選優惠",
      };
      return map[type] || type;
    },
    async deletePromotion(id) {
      const result = await Swal.fire({
        title: "確定要刪除嗎?",
        text: "刪除後無法復原",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "是的, 刪除!",
        cancelButtonText: "取消",
      });

      if (result.isConfirmed) {
        try {
          await axios.delete(`/api/admin/promotions/${id}`);
          this.promotions = this.promotions.filter((p) => p.id !== id);
          Swal.fire("已刪除!", "活動已刪除.", "success");
        } catch (error) {
          console.error(error);
          Swal.fire("錯誤!", "刪除失敗.", "error");
        }
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "無期限";
      return new Date(dateStr).toLocaleDateString();
    },
  },
};
</script>
